import axios from 'axios';
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from "../store";
import Vue from 'vue';

let base = '/aidrwebapi';
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
//let base = process.env.NODE_ENV=="production"? 'http://api.training.wanghuolou.cn:82':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:5001':'';
//let base = process.env.NODE_ENV=="production"? 'http://192.168.1.4:1004':'';

// 请求延时
axios.defaults.timeout = 60000

var storeTemp = store;
axios.interceptors.request.use(
    config => {
        var curTime = new Date()
        var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
        // if (storeTemp.state.token && (curTime < expiretime && storeTemp.state.tokenExpire)) {
        if (storeTemp.state.token) {
            // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.Authorization = "Bearer " + storeTemp.state.token;
        }
        saveRefreshtime();
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.status == 401) {
            var curTime = new Date()
            var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
            // 在用户操作的活跃期内
            if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                return refreshToken({ token: window.localStorage.Token }).then((res) => {
                    if (res.success) {
                        store.commit("saveToken", res.response.token);
                        var curTime = new Date();
                        var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                        store.commit("saveTokenExpire", expiredate);
                        error.config.__isRetryRequest = true;
                        error.config.headers.Authorization = 'Bearer ' + res.response.token;
                        return axios(error.config);
                    } else {
                        ToLogin()
                        return false;
                    }
                })
                .catch((err) => {
                    ToLogin()
                    return false;
                })
            } else {
                ToLogin()
                return false;
            }
        } else if (response.data.status == 403) {
            Vue.prototype.$message({
                message: '失败！该操作无权限',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 429) {
            Vue.prototype.$message({
                message: '刷新次数过多，请稍事休息重试！',
                type: 'error'
            });
            return null;
        } else if (response.data.status == 500) {
            setTimeout(function () {
                Vue.prototype.$message({
                    message: '服务器错误，请稍后重试！',
                    type: 'error'
                });
            }, 1000)
            return null;
        }
        return response;
    },
    error => {
        // 超时请求处理
        var originalRequest = error.config;
        console.log(error.config)
        if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
            Vue.prototype.$message({
                message: '请求超时！',
                type: 'error'
            });
            originalRequest._retry = true
            return null;
        }
        if (error.response) {
            if (error.response.status == 401) {
                var curTime = new Date()
                var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
                // 在用户操作的活跃期内
                if (window.localStorage.refreshtime && (curTime <= refreshtime)) {
                    return refreshToken({ token: window.localStorage.Token }).then((res) => {
                        if (res.success) {
                            // Vue.prototype.$message({
                            //     message: 'refreshToken success! loading data...',
                            //     type: 'success'
                            // });
                            store.commit("saveToken", res.response.token);
                            var curTime = new Date();
                            var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expiresIn));
                            store.commit("saveTokenExpire", expiredate);
                            error.config.__isRetryRequest = true;
                            error.config.headers.Authorization = 'Bearer ' + res.response.token;
                            return axios(error.config);
                        } else {
                            // 刷新token失败 清除token信息并跳转到登录页面
                            ToLogin()
                            return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                        }
                    });
                } else {
                    // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
                    ToLogin()
                    return false;   //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
                }
            }
            // 403 无权限
            if (error.response.status == 403) {
                Vue.prototype.$message({
                    message: '失败！该操作无权限',
                    type: 'error'
                });
                return null;
            }
            // 429 ip限流
            if (error.response.status == 429) {
                Vue.prototype.$message({
                    message: '刷新次数过多，请稍事休息重试！',
                    type: 'error'
                });
                return null;
            }
            // 500
            if (error.response.status == 500) {
                setTimeout(function () {
                    Vue.prototype.$message({
                        message: '服务器错误，请稍后重试！',
                        type: 'error'
                    });
                }, 1000)
                return null;
            }
        }
        return ""; // 返回接口返回的错误信息
    }
);
const ToLogin = params => {
    store.commit("saveToken", "");
    store.commit("saveTokenExpire", "");
    store.commit("saveTagsData", "");
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('NavigationBar');
    var routerGo = router.currentRoute.fullPath.substring(0, 6)
    if (routerGo == "/login") {
    } else {
        router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath }
        });
    }
    // router.replace({
    //     path: "/login",
    //     query: {redirect: router.currentRoute.fullPath}
    // });
    // 调试登录过期后重新登录第一次无法跳转到相应的页面，而是停留在登录页面，所以暂时注释，怀疑重新加载所以看不到console.log("redirect_api--") date:2020-12-23
    window.location.reload()
    return false;  //代码显示此处共走了n(n取决于页面create接口的请求次数)遍，所以让停止再执行看看效果 date:2020-12-23
};
export const BaseApiUrl = base;
export const saveRefreshtime = params => {
    let nowtime = new Date();
    let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1);
    let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))
    let refreshCount = 1;//滑动系数
    if (lastRefreshtime >= nowtime) {
        lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
        lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
        window.localStorage.refreshtime = lastRefreshtime;
    } else {
        window.localStorage.refreshtime = new Date(-1);
    }
};

// 系统登录
export const requestLogin = params => {
    return axios.post(`${base}/login/login`, params).then(res => res.data);
};

//AI系统登录
export const aiDoLogin = params => {
    return axios.get(`${base}/login/aiDoLogin`, { params: params });
};

// 获取登录短信验证码
export const getLoginCode = params => {
    return axios.get(`${base}/login/getLoginCode`, { params: params }).then(res => res.data);
};

// 短信验证码登录
export const codelogin = params => {
    return axios.get(`${base}/login/codelogin`, { params: params }).then(res => res.data);
};

//刷新token
export const refreshToken = params => {
    return axios.get(`${base}/login/refreshToken`, { params: params }).then(res => res.data);
};

// ==============================首页接口STAR======================================================================
//首页
//获取报名人数的图表数据
export const examenrollCountGroupByDate = params => {
    return axios.get(`${base}/Home/ExamenrollCountGroupByDate`, { params: params });
};
//根据行政区获取报名人数的图表数据
export const examenrollCountGroupByDateByID = params => {
    return axios.get(`${base}/Home/ExamenrollCountGroupByDateByID`, { params: params });
};

//获取考试项目报名人数统计
export const examenrollCountGroupByProjectName = params => {
    return axios.get(`${base}/Home/ExamenrollCountGroupByProjectName`, { params: params });
};
//根据行政区获取考试项目报名人数统计
export const examenrollCountGroupByProjectNameByID = params => {
    return axios.get(`${base}/Home/ExamenrollCountGroupByProjectNameByID`, { params: params });
};

// 社会单位总数及学习中数量
export const getUnitsAndCertificatesResponse = params => {
    return axios.get(`${base}/Home/getUnitsAndCertificatesResponse`, { params: params });
};

// 下级社会单位总数及学习中数量
export const getUnitsAndCertificatesResponseByID = params => {
    return axios.get(`${base}/Home/getUnitsAndCertificatesResponseByID`, { params: params });
};

// 下级城市/地区的社会单位、持证总数、证书达标数列表
export const getProportionCertificateHolders = params => {
    return axios.get(`${base}/Home/GetProportionCertificateHolders`, { params: params });
};

// 下级城市/地区的持证总数统计
export const getProportionCertificateHoldersByID = params => {
    return axios.get(`${base}/Home/GetProportionCertificateHoldersByID`, { params: params });
};

// 社会单位持证统计分析
export const getSocialUnitCertificateHoldersStatistics = params => {
    return axios.get(`${base}/Home/GetSocialUnitCertificateHoldersStatistics`, { params: params });
};

// 待监管单位
export const getHomeSocialUnitStatistics = params => {
    return axios.get(`${base}/Home/GetHomeSocialUnitStatistics`, { params: params });
};

// 地图滑上社会单位，学习中，取证，待监管数量
export const getUnitsAndCertificatesSingleResponseByID = params => {
    return axios.get(`${base}/Home/getUnitsAndCertificatesSingleResponseByID`, { params: params });
};
//获取社会单位明细
export const getSocialUnitListPage = params => {
    return axios.get(`${base}/Home/getSocialUnitListPage`, { params: params });
};

//首页改版新接口
// 共用-获取地图上方滑上浮窗数据
export const getStudentLearnRecords = params => {
    return axios.get(`${base}/Home/GetStudentLearnRecords`, { params: params });
};
// 共用-获取地图地标接口
export const getJsonFile = params => {
    return axios.get(`${base}/GeoJson/GetJsonFile`, { params: params });
};

// 概况
// 消防安全知识知晓率排名
export const getMaterialExamPaperRightRatio = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetMaterialExamPaperRightRatio`, { params: params });
};
// 获取待监管单位数/单位总数接口
export const getToBeSupervisedSocialUnitCount = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetToBeSupervisedSocialUnitCount`, { params: params });
};
// 本级概况
export const getTrainingExaminationCertificateStatistics = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetTrainingExaminationCertificateStatistics`, { params: params });
};
// 获取地图浮窗数据
export const getUnitAndSupervisionResponseStatistics = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndSupervisionResponseStatistics`, { params: params });
};
// 下辖概况
export const getTrainingExaminationCertificateByID = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetTrainingExaminationCertificateByID`, { params: params });
};
// 饼状图概况
export const getAgencyInfoPass = params => {
    return axios.get(`${base}/Home/getAgencyInfoPass`, { params: params });
};

// 报考情况
// 获取每日报考人数
export const getExamenrollCountGroupByDateByID = params => {
    return axios.get(`${base}/Home/ExamenrollCountGroupByDateByID`, { params: params });
};
// 根据岗位/行业获取报考人数/应训人数
export const getTrainingCountGroupByTradeByIDByType = params => {
    return axios.get(`${base}/Home/TrainingCountGroupByTradeByIDByType`, { params: params });
};
// 本级报考情况
export const getUnitAndRegistrationCountRateStatisticsByID = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndRegistrationCountRateStatisticsByID`, { params: params });
};
// 获取地图浮窗数据
export const getMapRegistrationRateResponseStatistics = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetMapRegistrationRateResponseStatistics`, { params: params });
};
// 下辖报考情况
export const getUnitAndRegistrationCountRateStatistics = params => {
    return axios.get(`${base}/GeneralizationStatistics/GetUnitAndRegistrationCountRateStatistics`, { params: params });
};

// 参训情况
// 获取每日参训人数
export const getAttendTrainingCountGroupByDate = params => {
    return axios.get(`${base}/Home/AttendTrainingCountGroupByDate`, { params: params });
};
// 根据岗位/行业获取参训人数/应训人数
export const getTrainingCountGroupByTradeByID = params => {
    return axios.get(`${base}/Home/TrainingCountGroupByTradeByID`, { params: params });
};
// 本级参训情况
export const getCurrentLevelParticipationByID = params => {
    return axios.get(`${base}/Home/GetCurrentLevelParticipationByID`, { params: params });
};
// 获取地图浮窗数据
export const getTrainingMap = params => {
    return axios.get(`${base}/Home/GetTrainingMap`, { params: params });
};
// 下辖参训情况
export const getParticipatingJurisdictions = params => {
    return axios.get(`${base}/Home/GetParticipatingJurisdictions`, { params: params });
};
// 参训人数概况
export const getTrainingCountByID = params => {
    return axios.get(`${base}/Home/GetTrainingCountByID`, { params: params });
};
// 获取乡镇下辖单位概况明细
export const getParticipatingJurisdictionsRegion = params => {
    return axios.get(`${base}/Home/GetParticipatingJurisdictionsRegion`, { params: params });
};

// 持证情况
// 获取每日取证人数
export const getCertificateCountGroupByDate = params => {
    return axios.get(`${base}/Home/GetCertificateCountGroupByDate`, { params: params });
};
// 根据岗位/行业获取持证人数/应训人数
export const getCertificateCountGroupByTradeByID = params => {
    return axios.get(`${base}/Home/CertificateCountGroupByTradeByID`, { params: params });
};
// 本级持证情况
export const getCurrentLevelCertificateHoldingByID = params => {
    return axios.get(`${base}/Home/GetCurrentLevelCertificateHoldingByID`, { params: params });
};
// 获取地图浮窗数据
export const getMapOfCertificateHolding = params => {
    return axios.get(`${base}/Home/GetMapOfCertificateHolding`, { params: params });
};
// 下辖持证情况
export const getCertificateHoldingUnderTheJurisdiction = params => {
    return axios.get(`${base}/Home/GetCertificateHoldingUnderTheJurisdiction`, { params: params });
};
// 持证人数概况
export const getCertificateCountByID = params => {
    return axios.get(`${base}/Home/GetCertificateCountByID`, { params: params });
};
// ===============================首页接口END===========================================================================

//系统管理
//用户管理
export const getUserListPage = params => {
    return axios.get(`${base}/userInfo/getUserInfoListPage`, { params: params });
};

// 根据token获取用户详细信息
export const getUserByToken = params => {
    return axios.get(`${base}/userInfo/getUserInfoByToken`, { params: params }).then(res => res.data);
};

//新增用户信息
export const addUserInfo = params => {
    return axios.post(`${base}/userInfo/addUserInfo`, params);
};

//更新用户信息
export const updateUserInfo = params => {
    return axios.post(`${base}/userInfo/updateUserInfo`, params);
};

//删除用户信息
export const deleteUserInfo = params => {
    return axios.delete(`${base}/userInfo/deleteUserInfo`, { params });
};

// 用户自定义页面列表设置
export const userPageUrlColumnValue = params => {
    return axios.get(`${base}/userInfo/userPageUrlColumnValue`, { params: params });
};

//发送修改密码手机短信验证码
export const sendModifyPasswordSMSVerificationCode = params => {
    return axios.post(`${base}/SystemManager/SendModifyPasswordSMSVerificationCode`, params);
};

//修改用户登录密码
export const modifyUserPassword = params => {
    return axios.post(`${base}/userInfo/modifyUserPassword`, params);
};

//系统管理
//菜单权限管理

//根据用户ID获取路由树
export const getNavigationBar = params => {
    return axios.get(`${base}/menuPermissions/getNavigationBar`, { params: params }).then(res => res.data);
};

//获取菜单树
export const getMenuTree = params => {
    return axios.get(`${base}/menuPermissions/getMenuTree`, { params: params });
};

//获取菜单权限树形列表
export const getMenuPermissionsTree = params => {
    return axios.get(`${base}/menuPermissions/getMenuPermissionsTree`, { params: params });
};

//新增菜单权限信息
export const addMenuPermissionsInfo = params => {
    return axios.post(`${base}/menuPermissions/addMenuPermissionsInfo`, params);
};

//更新菜单权限信息
export const updateMenuPermissionsInfo = params => {
    return axios.post(`${base}/menuPermissions/updateMenuPermissionsInfo`, params);
};

//删除菜单权限信息
export const deleteMenuPermissionsInfo = params => {
    return axios.delete(`${base}/menuPermissions/deleteMenuPermissionsInfo`, { params: params });
};

//保存菜单权限分配
export const assignMenuPermissions = params => {
    return axios.post(`${base}/menuPermissions/assignMenuPermissions`, params);
};

//通过角色获取菜单【无权限】
export const GetAssignMenuPermissionIdByRoleId = params => {
    return axios.get(`${base}/menuPermissions/getAssignMenuPermissionIdByRoleId`, { params: params });
};

//系统管理
//角色管理

//根据组织结构ID获取角色信息集合
export const getRoleInfosByOrganizationInfoID = params => {
    return axios.get(`${base}/roleInfo/getRoleInfoByName`, { params: params });
};

//获取角色信息分页列表
export const getRoleListPage = params => {
    return axios.get(`${base}/roleInfo/getRoleInfoListPage`, { params: params });
};

//新增角色信息
export const addRoleInfo = params => {
    return axios.post(`${base}/roleInfo/addRoleInfo`, params);
};

//更新角色信息
export const updateRoleInfo = params => {
    return axios.post(`${base}/roleInfo/updateRoleInfo`, params);
};

//删除角色信息
export const deleteRoleInfo = params => {
    return axios.delete(`${base}/roleInfo/deleteRoleInfo`, { params: params });
};

//系统管理
// 部门管理

//获取组织结构树
export const getOrganizationTree = params => {
    return axios.get(`${base}/departmentInfo/getDepartmentTree`, { params: params });
};

//新增组织结构信息
export const addOrganizationInfo = params => {
    return axios.post(`${base}/departmentInfo/addDepartmentInfo`, params);
};

//更新组织结构信息
export const updateOrganizationInfo = params => {
    return axios.post(`${base}/departmentInfo/updateDepartmentInfo`, params);
};

//删除组织结构信息
export const deleteOrganizationInfo = params => {
    return axios.delete(`${base}/departmentInfo/deleteDepartmentInfo`, { params: params });
};

//系统管理
// 接口管理

//获取接口信息树形列表
export const getApiModulesInfoTree = params => {
    return axios.get(`${base}/apiModulesInfo/getApiModulesInfoTree`, { params: params });
};

//获取接口菜单树
export const getApiMenuTree = params => {
    return axios.get(`${base}/apiModulesInfo/getApiMenuTree`, { params: params });
};

//新增接口信息
export const addApiModulesInfo = params => {
    return axios.post(`${base}/apiModulesInfo/addApiModulesInfo`, params);
};

//更新接口信息
export const updateApiModulesInfo = params => {
    return axios.post(`${base}/apiModulesInfo/updateApiModulesInfo`, params);
};

//删除接口信息
export const deleteApiModulesInfo = params => {
    return axios.delete(`${base}/apiModulesInfo/deleteApiModulesInfo`, { params: params });
};

//系统管理
// 数据权限管理

//获取全部数据权限信息列表
export const getAllDataPermissionsInfoList = params => {
    return axios.get(`${base}/dataPermissionsInfo/getAllDataPermissionsInfoList`, { params: params });
};

//新增数据权限信息
export const addDataPermissionsInfo = params => {
    return axios.post(`${base}/dataPermissionsInfo/addDataPermissionsInfo`, params);
};

//更新数据权限信息
export const updateDataPermissionsInfo = params => {
    return axios.post(`${base}/dataPermissionsInfo/updateDataPermissionsInfo`, params);
};

//删除数据权限信息
export const deleteDataPermissionsInfo = params => {
    return axios.delete(`${base}/dataPermissionsInfo/deleteDataPermissionsInfo`, { params });
};

//保存数据权限分配
export const assignDataPermissions = params => {
    return axios.post(`${base}/dataPermissionsInfo/assignDataPermissions`, params);
};

//通过角色ID获取数据权限菜单【无权限】
export const getAssignDataPermissionIdByRoleId = params => {
    return axios.get(`${base}/dataPermissionsInfo/getAssignDataPermissionIdByRoleId`, { params: params });
};

//通用设置
//审批流程管理

//获取审批流程信息分页列表
export const getApprovalProcessListPage = params => {
    return axios.get(`${base}/CommonSettings/GetApprovalProcessListPage`, { params: params });
};

//新增审批流程
export const addApprovalProcess = params => {
    return axios.post(`${base}/CommonSettings/AddApprovalProcess`, params);
};

//更新审批流程
export const updateApprovalProcess = params => {
    return axios.post(`${base}/CommonSettings/UpdateApprovalProcess`, params);
};

//根据审批流程ID 获取审批流程图
export const getApprovalProcessDiagramByApprovalProcessID = params => {
    return axios.get(`${base}/CommonSettings/GetApprovalProcessDiagramByApprovalProcessID`, { params: params });
};

//通用设置
//展示信息

//获取展示信息分页集合
export const getShowInformationListPage = params => {
    return axios.get(`${base}/CommonSettings/GetShowInformationListPage`, { params: params });
};

//新增展示信息
export const addShowInformation = params => {
    return axios.post(`${base}/CommonSettings/AddShowInformation`, params);
};

//更新展示信息
export const updateShowInformation = params => {
    return axios.post(`${base}/CommonSettings/UpdateShowInformation`, params);
};

//删除展示信息
export const deleteShowInformation = params => {
    return axios.post(`${base}/CommonSettings/DeleteShowInformation`, params);
};

//顶置/取消顶置展示信息
export const setTopShowInformation = params => {
    return axios.post(`${base}/CommonSettings/SetTopShowInformation`, params);
};

//通用设置
//轮播信息

//获取轮播信息分页集合
export const getCarouselInformationList = params => {
    return axios.get(`${base}/CommonSettings/GetCarouselInformationList`, { params: params });
};

//新增轮播信息
export const addCarouselInformation = params => {
    return axios.post(`${base}/CommonSettings/AddCarouselInformation`, params);
};

//更新轮播信息
export const updateCarouselInformation = params => {
    return axios.post(`${base}/CommonSettings/UpdateCarouselInformation`, params);
};

//删除轮播信息
export const deleteCarouselInformation = params => {
    return axios.post(`${base}/CommonSettings/DeleteCarouselInformation`, params);
};

//通用设置
//行政区域

//获取行政区信息列表
// export const getAreaDictionaryList = params => {
//     return axios.get(`${base}/CommonSettings/GetAreaDictionaryList`, { params: params });
// };

// 省市区(code)
export const getAreaDictionaryByCode = params => {
    return axios.get(`${base}/areaDictionary/getAreaDictionaryByCode`, { params: params });
};
// 省市区(id)
export const getAreaDictionaryById = params => {
    return axios.get(`${base}/areaDictionary/getAreaDictionaryById`, { params: params });
};

// 省市区
export const getAreaDictionaryList = params => {
    return axios.get(`${base}/areaDictionary/getAreaDictionaryList`, { params: params });
};
// 省市区
export const getAreaDictionaryListWithCode = params => {
    return axios.get(`${base}/areaDictionary/getAreaDictionaryListWithCode`, { params: params });
};

//新增行政区信息
export const addAreaDictionary = params => {
    return axios.post(`${base}/CommonSettings/AddAreaDictionary`, params);
};

//更新行政区信息
export const updateAreaDictionary = params => {
    return axios.post(`${base}/CommonSettings/UpdateAreaDictionary`, params);
};

//删除行政区信息
export const deleteAreaDictionary = params => {
    return axios.post(`${base}/CommonSettings/DeleteAreaDictionary`, params);
};

//抓取行政区信息
export const grabAreaDictionary = params => {
    return axios.post(`${base}/CommonSettings/GrabAreaDictionary`, params);
};

//通用设置
//数据字典信息

//获取数据字典信息列表
export const getDataDictionaryList = params => {
    return axios.get(`${base}/dataDictionary/getById`, { params: params });
};

//新增数据字典信息
export const addDataDictionary = params => {
    return axios.post(`${base}/CommonSettings/AddDataDictionary`, params);
};

//更新数据字典信息
export const updateDataDictionary = params => {
    return axios.post(`${base}/CommonSettings/UpdateDataDictionary`, params);
};

//删除数据字典信息
export const deleteDataDictionary = params => {
    return axios.post(`${base}/CommonSettings/DeleteDataDictionary`, params);
};
// 根据命名空间获取数据字典
export const getByNamespace = params => {
    return axios.get(`${base}/dataDictionary/getByNamespace`, { params: params });
};


//工作流管理
//审批
export const approve = params => {
    return axios.post(`${base}/WorkFlow/Approve`, params);
};

//获取待处理信息分页列表
export const getPendingIssuesListPage = params => {
    return axios.get(`${base}/WorkFlow/GetPendingIssuesListPage`, { params: params });
};

//获取已处理信息分页列表
export const getProcessedIssuesListPage = params => {
    return axios.get(`${base}/WorkFlow/GetProcessedIssuesListPage`, { params: params });
};

//获取已发起信息分页列表
export const getLaunchIssuesListPage = params => {
    return axios.get(`${base}/WorkFlow/GetLaunchIssuesListPage`, { params: params });
};

//获取全部事项分页列表
export const getAllIssuesListPage = params => {
    return axios.get(`${base}/WorkFlow/GetAllIssuesListPage`, { params: params });
};

//根据审批记录ID获取试题审批记录详情
export const getExaminationQuestionsApprovalRecordByID = params => {
    return axios.get(`${base}/WorkFlow/GetExaminationQuestionsApprovalRecordByID`, { params: params });
};

//根据审批记录ID获取发布考试项目详情
export const getPublishExamProjectInfoByID = params => {
    return axios.get(`${base}/WorkFlow/GetPublishExamProjectInfoByID`, { params: params });
};

//图片管理
//上传图片
export const uploadTempPic = params => {
    return axios.post(`${base}/Image/UploadTempPic`, params);
};

// 上传图片路径
export const uploadImagesUrl = `${base}/fileTransfer/uploadPic`




export const uploadPic = params => {
    return axios.post(`${base}/fileTransfer/uploadPic`, params);
};




// 项目管理
// 项目登记

//退回
export const returnUploadKYJCProjectStatus = params => {
    return axios.get(`${base}/drProject/returnUploadKYJCProjectStatus`, {params:params});
};

//完成项目登记（开业检查）
export const isCompletedKYJCProject = params => {
    return axios.get(`${base}/drProject/isCompletedKYJCProject`, {params:params});
};

//获取工作日时长
export const getProjectListTime = params => {
    return axios.get(`${base}/drProject/getWorkDateNum?from=`+ params.from+'&'+'to='+ params.to);
};

//获取申报表
export const getKYJCApplicationByProjectId = params => {
    return axios.get(`${base}/drProject/getKYJCApplicationByProjectId`, { params: params });
};

// 获取项目分页列表
export const getProjectList = params => {
    return axios.get(`${base}/drProject/getProjectList`, { params: params });
};

// 新增项目
export const addProject = params => {
    return axios.post(`${base}/drProject/addProject`, params);
};
export const convertFormalProject = params => {
    return axios.post(`${base}/drProject/convertFormalProject`, params);
};

//上传申报表
export const addProjectFile = params => {
    return axios.post(`${base}/kyjc/addProjectFile`, params);
};
//更新开业检查项目申报表
export const updateProjectFile = params => {
    return axios.post(`${base}/kyjc/updateProject`, params);
};
//获取用户信息
export const getAccountInfo = params => {
    return axios.get(`${base}/kyjc/getAccountInfo`, { params: params });
};
//获取开业检查项目申报表详情
export const getApplicationByProjectId = params => {
    return axios.get(`${base}/kyjc/getApplicationByProjectId`, { params: params });
};

//获取开业检查流程列表
export const getKYJCProjectStageList = params => {
    return axios.get(`${base}/drProject/getKYJCProjectStageList`, { params: params });
};



// 更新项目
export const updateProject = params => {
    return axios.post(`${base}/drProject/updateProject`, params);
};

// 更新部分项目信息
export const updateProjectInfo = params => {
    return axios.post(`${base}/drProject/updateProjectInfo`, params);
};

// 重新审图
export const resetDrawingReviewApi = params => {
    return axios.post(`${base}/drProject/resetDrawingReview`, params);
};

// 更新审查报告编号
export const updateCustomReportNo = params => {
    return axios.post(`${base}/drProject/updateCustomReportNo`, params);
};

// 新增项目申请表
export const addProjectApplication = params => {
    return axios.post(`${base}/drProject/addProjectApplication`, params);
}

// 更新项目申请表
export const updateProjectApplication = params => {
    return axios.post(`${base}/drProject/updateProjectApplication`, params);
}

// 完成登记项目接口
export const registerProject = params => {
    return axios.get(`${base}/drProject/registerProject`, { params: params });
};

// 获取项目文件目录
export const getProjectFileInfo = params => {
    return axios.get(`${base}/drProject/getProjectFileInfo`, { params: params });
};

export const getProjectFileInfoByFlowNodeId = params => {
    return axios.get(`${base}/drProject/getProjectFileInfoByFlowNodeId`, { params: params });
};

// 获取项目详情
export const getProjectById = params => {
    return axios.get(`${base}/drProject/getProjectById`, { params: params });
};

//获取项目文件标签信息
export const getProjectFileTag = params => {
    return axios.get(`${base}/drProject/getProjectFileTag`, {params:params});
};

//生成临时Url链接
export const generateTemporaryUrlByFileName = params => {
    return axios.get(`${base}/fileTransfer/generateTemporaryUrlByFileName`, { params: params });
};

//获取项目压缩文件
export const getCompressedProjectFile = params => {
    return axios.get(`${base}/fileTransfer/getCompressedProjectFile`, { params: params });
};

export const generateTemporaryUrl = params => {
    return axios.get(`${base}/fileTransfer/generateTemporaryUrl`, { params: params });
};

// 根据项目ID获取阶段列表
export const getStageListByProjectId = params => {
    return axios.get(`${base}/drProject/getStageListByProjectId`, { params: params });
};


// 获取合同详情
export const getDrContractById = params => {
    return axios.get(`${base}/drContract/getDrContractById`, { params: params });
};

// 根据项目Id获取项目申请表
export const getProjectApplicationByProjectId = params => {
    return axios.get(`${base}/drProject/getProjectApplicationByProjectId`, { params: params });
};

// 上传识别文件
export const uploadApplicationPic = params => {
    return axios.post(`${base}/drProject/uploadApplicationPic`, params);
}
// 上传识别文件
export const uploadApplicationPicUrl = `${base}/drProject/ocrApplicationPic`

//验收管理 文件上传
export const uploadFile = `${base}/fileTransfer/uploadFile`

// 在审项目管理
// 在审项目

// 获取在审项目分页列表
export const getCheckingProjectList = params => {
    return axios.get(`${base}/drProject/getCheckingProjectList`, {params: params});
};

//在审项目（开业检查）
//更换在线专家
export const changeKYJCTaskUserId = params => {
    return axios.post(`${base}/drTask/changeKYJCTaskUserId`, params);
}
//查看相似项目
export const getSameKYJCProjectListByGeo = params => {
    return axios.get(`${base}/drProject/getSameKYJCProjectListByGeo`, {params: params});
}

//快速生成报告
export const generationPreviousDrawingReviewReport = params => {
    return axios.get(`${base}/drOpinionSummary/generationPreviousDrawingReviewReport`, {params: params});
};

// 审结项目
export const conclusionProject = params => {
    return axios.post(`${base}/drProject/conclusionProject`, params);
};

// 申请援助
export const applyAssistance = params => {
    return axios.post(`${base}/drTask/applyAssistance`, params);
};

// 重新发起签章
export const signatureProject = params => {
    return axios.post(`${base}/drProject/resetProjectSign`, params);
};

//获取留言
export const getProjectMessageByProjectId = params => {
    return axios.get(`${base}/drProject/getProjectMessageByProjectId`, { params: params });
};

// 新增留言
export const addProjectMessage = params => {
    return axios.post(`${base}/drProject/addProjectMessage`, params);
};

//获取项目参与人员
export const getProjectParticipants = params => {
    return axios.get(`${base}/drProject/getProjectParticipantsByAi`, { params: params });
};

export const getProjectParticipantsOld = params => {
    return axios.get(`${base}/drProject/getProjectParticipants`, { params: params });
};
//更改到期时间

export const changeTaskOverdueDate = params => {
    return axios.post(`${base}/drTask/changeTaskOverdueDate`,  params );
};

//复核报告
export const getProjectReports = params => {
    return axios.get(`${base}/drProject/getProjectDoubleReports`, { params: params });
};

//图审人员初审意见
export const getPreliminaryTrialOpinionListByPrProjectId = params => {
    return axios.get(`${base}/drOpinion/getPreliminaryTrialOpinionListByPrProjectId`, { params: params });
};

//查看审图意见
export const getOpinionListByWorkFlowId = params => {
    return axios.get(`${base}/drOpinion/getOpinionListByWorkFlowId`, { params: params });
};


//图审人员初审报告（弃用）
export const getPreliminaryReviewReportByPrProjectId = params => {
    return axios.get(`${base}/drOpinionSummary/getPreliminaryReviewReportByPrProjectId`, { params: params });
};

//图审人员初审报告
export const getProjectFirstReports = params => {
    return axios.get(`${base}/drProject/getProjectFirstReports`, { params: params });
};

//图审报告
export const getProjectConclusionReports = params => {
    return axios.get(`${base}/drProject/getProjectConclusionReports`, { params: params });
};

//图审人员复核报告
export const getProjectDoubleReports = params => {
    return axios.get(`${base}/drProject/getProjectDoubleReports`, { params: params });
};

//图审人员复核列表
export const getTaskReviewList = params => {
    return axios.get(`${base}/drTask/getTaskReviewList`, { params: params });
};

//图审人员此次复核意见列表
export const getReviewOpinionList = params => {
    return axios.get(`${base}/drOpinion/getReviewOpinionList`, { params: params });
};

//项目审结期限倒计时天数
export const getProjectConclusionExpire = params => {
    return axios.get(`${base}/drProject/getProjectConclusionExpire`, { params: params });
};

// 不合格项目归档

// 不合格项目列表
export const getDrProjectUnqualifiedList = params => {
    return axios.get(`${base}/drProject/getDrProjectUnqualifiedList`, { params: params });
};

// 项目异常处理
export const handleUnqualifiedProject = params => {
    return axios.get(`${base}/drProject/handleUnqualifiedProject`, { params: params });
};

// 档案查询

// 获取档案列表
export const getDrProjectFiledtList = params => {
    return axios.get(`${base}/drProject/getDrProjectFiledtList`, { params: params });
};

//统计汇总
//统计汇总
export const getStatisticsFirstOpinionList = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsFirstOpinionList`, { params: params });
}
//获取意见明细列表
export const getStatisticsKYJCOpininDetail = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCOpininDetail`, { params: params });
};

// 获取意见汇总
export const getStatisticsKYJCOpininList = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCOpininList`, { params: params });
};

//审查情况分析
export const getStatisticsKYJCAiStandardData = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCAiStandardData`, { params: params });
};
//审查情况分析（事项范围）
export const getStatisticsKYJCAiStandardItemTypeData = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCAiStandardItemTypeData`, { params: params });
};

//审查情况分析复审
export const getStatisticsKYJCReviewAiStandardData = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCReviewAiStandardData`, { params: params });
};

// 规范
//获取规范列表
export const getDrStandardList = params => {
    return axios.get(`${base}/drStandard/getDrStandardList`, { params: params });
};

// 获取单个规范内容
export const getDrStandardById = params => {
    return axios.get(`${base}/drStandard/getDrStandardById`, { params: params });
};

// 规范新增
export const addDrStandard = params => {
    return axios.post(`${base}/drStandard/addDrStandard`, params);
};

// 规范编辑
export const updateDrStandard = params => {
    return axios.post(`${base}/drStandard/updateDrStandard`, params);
};

// 规范删除
export const deleteDrStandard = params => {
    return axios.delete(`${base}/drStandard/deleteDrStandard`, { params: params });
};

// 所有规范 无分页
export const getAllDrStandardList = params => {
    return axios.get(`${base}/drStandard/getAllDrStandardList`, { params: params });
};

// 规范名下所有条文
export const getAllDrStandardItemList = params => {
    return axios.get(`${base}/drStandard/getAllDrStandardItemList`, { params: params });
};

// 条文
//获取条文列表
export const getDrStandardItemList = params => {
    return axios.get(`${base}/drStandardItem/getDrStandardItemList`, { params: params });
};
export const getDrStandardItemAllList = params => {
    return axios.get(`${base}/drStandardItem/getCustomAIStandardItemList`, { params: params });
};

// 获取条文信息
export const getDrStandardItemById = params => {
    return axios.get(`${base}/drStandardItem/getDrStandardItemById`, { params: params });
};

// 查询条文
export const getDrStandardItem = params => {
    return axios.get(`${base}/drStandardItem/getDrStandardItem`, { params: params });
};

// 条文新增
export const addDrStandardItem = params => {
    return axios.post(`${base}/drStandardItem/addDrStandardItem`, params);
};

// 新增条文规则 (款 项 目)
export const addDrStandardItemRule = params => {
    return axios.post(`${base}/drStandardItem/addDrStandardItemRule`, params);
};


// 条文编辑
export const updateDrStandardItem = params => {
    return axios.post(`${base}/drStandardItem/updateDrStandardItem`, params);
};

// 条文删除
export const deleteDrStandardItem = params => {
    return axios.delete(`${base}/drStandardItem/deleteDrStandardItem`, { params: params });
};

// 查看条文注释
export const getDrStandardItemNotesList = params => {
    return axios.get(`${base}/drStandardItem/getDrStandardItemNotesList`, { params: params });
};

// 查看条文所有注释
export const getAllStandardItemNotesByItemRootId = params => {
    return axios.get(`${base}/drStandardItem/getAllStandardItemNotesByItemRootId`, { params: params });
};

// 保存注
export const saveDrStandardItemNotes = params => {
    return axios.post(`${base}/drStandardItem/saveDrStandardItemNotes`, params);
};

// 注删除
export const deleteDrStandardItemNotes = params => {
    return axios.delete(`${base}/drStandardItem/deleteDrStandardItemNotes`, { params: params });
};

// 审查内容
//获取审查内容分页列表
export const getAuditContentListPage = params => {
    return axios.get(`${base}/drAuditContent/getAuditContentListPage`, { params: params });
};

// 获取所有审查对象
export const getAuditContentAllList = params => {
    return axios.get(`${base}/drAuditContent/getAuditContentAllList`, { params: params });
};

// 获取审查对象树状图
export const getAuditContentTreeList = params => {
    return axios.get(`${base}/drAuditContent/getAuditContentTreeList`, { params: params });
};

// 查询审查内容
export const getAuditContentById = params => {
    return axios.get(`${base}/drAuditContent/getAuditContentById`, { params: params });
};

// 审查内容新增
export const addAuditContent = params => {
    return axios.post(`${base}/drAuditContent/addAuditContent`, params);
};

// 审查内容编辑
export const updateAuditContent = params => {
    return axios.post(`${base}/drAuditContent/updateAuditContent`, params);
};

// 审查内容删除
export const deleteAuditContent = params => {
    return axios.delete(`${base}/drAuditContent/deleteAuditContent`, { params: params });
};

// 问题库
//获取问题库分页列表
export const getQuestionPageList = params => {
    return axios.get(`${base}/drQuestion/getQuestionPageList`, { params: params });
};

// 根据问题编号或内容获取问题库列表
export const getQuestionById = params => {
    return axios.get(`${base}/drQuestion/getQuestionById`, { params: params });
};

// 问题库新增
export const addQuestion = params => {
    return axios.post(`${base}/drQuestion/addQuestion`, params);
};

// 问题库编辑
export const updateQuestion = params => {
    return axios.post(`${base}/drQuestion/updateQuestion`, params);
};

// 问题库删除
export const deleteQuestion = params => {
    return axios.delete(`${base}/drQuestion/deleteQuestion`, { params: params });
};

// 图审人员
// 查询
export const getExpertDataDictRelationList = params => {
    return axios.get(`${base}/expertDataDictRelation/getExpertDataDictRelationList`, { params: params });
};
//获取验收专家列表
export const getLocalExpertList = params => {
    return axios.get(`${base}/aeProject/getLocalExpertList`, { params: params });
};
//验收管理接口 分配初验驻场人员
export const assignLocalExpertUsers = params => {
    return axios.post(`${base}/aeProject/assignLocalExpertUsers`, params);
};
//追加初验驻场人员
export const appendLocalExpertUsers = params => {
    return axios.post(`${base}/aeProject/appendLocalExpertUsers`, params);
};
//验收 获取当前意见列表
export const getCurrentOpinionList = params => {
    return axios.get(`${base}/aeProject/getCurrentOpinionList`, { params: params });
};
//验收 添加意见
export const addOpinion = params => {
    return axios.post(`${base}/aeProject/addOpinion`, params);
};
//验收 获取项目阶段明细
export const getAcceptanceByProjectId = params => {
    return axios.get(`${base}/aeProject/getStageListByProjectId`, { params: params });
};
//验收 获取指定阶段意见列表（清单）
export const getChecklistOpinionListByWorkFlowId = params => {
    return axios.get(`${base}/aeProject/getChecklistOpinionListByWorkFlowId`, { params: params });
};
//验收 获取指定阶段评定报告
export const getReportInfoByWorkFlowId = params => {
    return axios.get(`${base}/aeProject/getReportInfoByWorkFlowId`, { params: params });
};
//验收 获取指定阶段意见列表
export const getOpinionListByWorkFlowIdAcceptance = params => {
    return axios.get(`${base}/aeProject/getOpinionListByWorkFlowId`, { params: params });
};
//验收 确认生成清单(阅卷）
export const generateCheckList = params => {
    return axios.post(`${base}/aeProject/generateCheckList`, params);
};
//验收 确认生成清单（交卷）
export const submitConfirmOpinion = params => {
    return axios.post(`${base}/aeProject/submitConfirmOpinion`, params);
};
//验收 获取指定阶段评定报告
export const getReportInfoByWorkFlowIdAcceptance = params => {
    return axios.get(`${base}/aeProject/getReportInfoByWorkFlowId`, { params: params });
};
//验收 获取当前评定报告
export const getCurrentReportInfo = params => {
    return axios.get(`${base}/aeProject/getCurrentReportInfo`, { params: params });
};
//验收 修改报告意见
export const updateReportOptions = params => {
    return axios.post(`${base}/aeProject/updateReportOptions`, params);
};
//验收 修改意见
export const updateOptions = params => {
    return axios.post(`${base}/aeProject/updateOptions`, params);
};
//验收 生成评定报告
export const generateReport = params => {
    return axios.post(`${base}/aeProject/generateReport`, params);
};
//验收 添加复验
export const addReviewTask = params => {
    return axios.post(`${base}/aeProject/addReviewTask`, params);
};
//验收 checklist编辑
export const updateChecklistOptions = params => {
    return axios.post(`${base}/aeProject/updateChecklistOptions`, params);
};
//验收 编辑工程项目
export const updateEngineerProject = params => {
    return axios.post(`${base}/aeProject/updateProject`, params);
};



export const registerReviewProject = params => {
    return axios.post(`${base}/drProject/registerReviewProject`, params);
};

// 复核项目多人分配
export const registerMultipleReviewProject = params => {
    return axios.post(`${base}/drProject/registerMultipleReviewProject`, params);
};

// 专家审核登记
export const registerExpertProject = params => {
    return axios.post(`${base}/drProject/registerExpertProject`, params);
};

// 新增
export const addExpertDataDictRelation = params => {
    return axios.post(`${base}/expertDataDictRelation/addExpertDataDictRelation`, params);
};
// 编辑
export const updateExpertDataDictRelation = params => {
    return axios.post(`${base}/expertDataDictRelation/updateExpertDataDictRelation`, params);
};
// 删除
export const deleteExpertDataDictRelation = params => {
    return axios.delete(`${base}/expertDataDictRelation/deleteExpertDataDictRelation`, { params: params });
};

// 合同管理

// 合同列表
export const getDrContractList = params => {
    return axios.get(`${base}/drContract/getDrContractList`, { params: params });
};

// 获取当前登陆人的有效合同
export const getCurrentDrContract = params => {
    return axios.get(`${base}/drContract/getCurrentDrContract`, { params: params });
};
//获取当前登录人的有效项目
export const getCurrentDrContractList = params => {
    return axios.get(`${base}/drContract/getCurrentDrContractList`, { params: params });
};
// 验收意见 获取当前清单意见列表
export const getCurrentChecklistOpinionList = params => {
    return axios.get(`${base}/aeProject/getCurrentChecklistOpinionList`, { params: params });
};
//验收 删除现场评定清单意见
export const deleteOpinionAcceptance = params => {
    return axios.get(`${base}/aeProject/deleteOpinion`, { params: params });
};

// 合同联系人列表
export const getContractContactUser = params => {
    return axios.get(`${base}/drContract/getContractContactUser`, { params: params });
};

// 合同联系人列表
export const getContractApplyUser = params => {
    return axios.get(`${base}/drContract/getContractApplyUser`, { params: params });
};

// 合同联系人列表
export const getContractCollaboratorUser = params => {
    return axios.get(`${base}/drContract/getContractCollaboratorUser`, { params: params });
};

// 受领任务

// 获取受领任务列表
export const getTaskApplyList = params => {
    return axios.get(`${base}/drTask/getApplyList`, { params: params });
};

// 处理任务接口
export const confirmTask = params => {
    return axios.post(`${base}/drTask/confirmTask`, params);
};

//验收项目 新建项目
export const addProjectAcceptance = params => {
    return axios.post(`${base}/aeProject/addProject`, params);
};

// 待指派任务
// 获取受领任务列表
export const getTaskAssignList = params => {
    return axios.get(`${base}/drTask/getAssignList`, { params: params });
};

// 分配任务接口
export const assignTask = params => {
    return axios.post(`${base}/drTask/assignTask`, params);
};

// 根据任务ID获取任务详情列表
export const getTaskDetailList = params => {
    return axios.get(`${base}/drTask/getTaskDetailByIds`, { params: params });
};

//修改技术部专家
export const changeAssignedUserIdByTechExpert = params => {
    return axios.post(`${base}/drTask/changeAssignedUserIdByTechExpert`, params);
};

// 结算考核
// 经营报表

// 获取经营报表分页列表
export const getProjectListObject = params => {
    return axios.get(`${base}/drProjectSt/getProjectConclusionReportList`, { params: params });
};

// 获取经营报表汇总
export const getProjectConclusionSummary = params => {
    return axios.get(`${base}/drProjectSt/getProjectConclusionSummary`, { params: params });
};
//验收管理
//获取项目分页列表
export const getAcceptanceProjectList = params => {
    return axios.get(`${base}/aeProject/getProjectList`, { params: params });
};
//获取验收问题库分页列表
export const getAcceptanceQuestionPageList = params => {
    return axios.get(`${base}/drQuestion/getAcceptanceQuestionPageList`, { params: params });
};

// 业绩考核
// 业绩考核列表
export const getPerformanceReportList = params => {
    return axios.get(`${base}/drPerformanceAssessmentSt/getPerformanceReportList`, { params: params });
};
//绩效考核列表
export const getUserStatisticList = params => {
    return axios.get(`${base}/drPerformanceAssessmentSt/getUserStatisticList`, { params: params });
};
//绩效明细详情
export const getStatisticsProjectDetailReportData = params => {
    return axios.get(`${base}/drPerformanceAssessmentSt/getStatisticsProjectDetailReportData`, { params: params });
};

//工程师审查汇总列表
export const getStatisticsKYJCProjectList = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCProjectList`, { params: params });
}
//工程师审查明细
export const getStatisticsKYJCProjectDetail = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCProjectDetail`, { params: params });
}

// 获取审核员项目明细列表
export const getUserProjectDetailList = params => {
    return axios.get(`${base}/drPerformanceAssessmentSt/getUserProjectDetailList`, { params: params });
};
//获取用户的项目行为日志
export const getUserProjectBehaviorList = params => {
    return axios.get(`${base}/UserBehavior/getUserProjectBehaviorList`, { params: params });
};
//通过流程节点获取用户行为日志
export const getUserBehaviorLogByWorkFlowNodeId = params => {
    return axios.get(`${base}/UserBehavior/getUserBehaviorLogByWorkFlowNodeId`, { params: params });
};

// 获取审核员拒领项目列表
export const getUserRefuseProjectList = params => {
    return axios.get(`${base}/drPerformanceAssessmentSt/getUserRefuseProjectList`, { params: params });
};

// 应收款周期报表分页列表
export const getFinancialReceivableListPage = params => {
    return axios.get(`${base}/financialReceivableCycle/getFinancialReceivableListPage`, { params: params });
};

//获取营收账单分页列表
export const getBillList = params => {
    return axios.get(`${base}/financialRevenue/getBillList`, { params: params });
};

// 应收款周期报表分页列表  催收通知  警示通知
export const getNotificationListPageByContractIdAndCycleId = params => {
    return axios.get(`${base}/financialReceivableCycle/getNotificationListPageByContractIdAndCycleId`, { params: params });
};
// 应收款周期报表分页列表  获取待核销的所有银行流水凭证
export const getPaymentsByNoMatchList = params => {
    return axios.get(`${base}/financialReceivableCycle/getPaymentsByNoMatchList`, { params: params });
};
// 应收款周期报表分页列表  流水匹配（匹配实收到对应周期报表）
export const addRevenuePaymentDetail = params => {
    return axios.post(`${base}/financialReceivableCycle/addRevenuePaymentDetail`, params);
};
// 应收款周期报表分页列表  流水匹配（根据应收款报表ID、获取该周期报表下的所有匹配明细）
export const getPaymentDetailListPageByCycleId = params => {
    return axios.get(`${base}/financialReceivableCycle/getPaymentDetailListPageByCycleId`, { params: params });
};
// 应收款周期报表分页列表  获取应收款周期报表对应的项目明细接口
export const getProjectByCycleId = params => {
    return axios.get(`${base}/financialReceivableCycle/getProjectByCycleId`, { params: params });
};
//应收款报表分页列表 项目
export const getProjectListByIds = params => {
    return axios.get(`${base}/drProject/getProjectListByIds`, { params: params });
};
//应收款报表明细列表
export const getReportList = params => {
    return axios.get(`${base}/financialRevenue/getReportList`, { params: params });
};
//应收款报表明细 合同ID
export const getCompanyContractList = params => {
    return axios.get(`${base}/financialRevenue/getCompanyContractList`, { params: params });
};
//汇总月
export const getBillDetailByMonth = params => {
    return axios.get(`${base}/financialRevenue/getBillDetailByMonth`, { params: params });
};


// 应收款周期报表分页列表  应收款报表按周期采集数据接口
export const addFinancialReceivableByContractID = params => {
    return axios.get(`${base}/financialReceivableCycle/addFinancialReceivableByContractID`, { params: params });
};
// 获取应收款周期报表下的合同列表
export const getProjectByContractId = params => {
    return axios.get(`${base}/financialReceivableCycle/getProjectByContractId`, { params: params });
};

//营收管理
//银行收款凭证列表
export const getIncomePaymentList = params => {
    return axios.get(`${base}/financialRevenue/getIncomePaymentList`, { params: params });
};
//获取发票列表
export const getInvoiceList = params => {
    return axios.get(`${base}/financialRevenue/getInvoiceList`, { params: params });
};

export const getAllProjectList = params => {
    return axios.get(`${base}/drProject/getAllProjectList`, { params: params });
};

export const getInvoiceDetailList = params => {
    return axios.get(`${base}/financialRevenue/getInvoiceDetailList`, { params: params });
};
export const getUnMatchInvoiceList = params => {
    return axios.get(`${base}/financialRevenue/getUnMatchInvoiceList`, { params: params });
};
//获取项目列表
export const getProjectMatchList = params => {
    return axios.get(`${base}/drProjectSt/getProjectConclusionReportList`, { params: params });
};
export const getProjectConclusionReportList = params => {
    return axios.get(`${base}/drProjectSt/getProjectConclusionReportList`, { params: params });
};
//匹配发票
export const matchRevenuePaymentByInvoice = params => {
    return axios.post(`${base}/financialRevenue/matchRevenuePaymentByInvoice`,  params );
};
//匹配项目
export const matchRevenuePaymentByProject = params => {
    return axios.post(`${base}/financialRevenue/matchRevenuePaymentByProject`, params);
};
//申请发票
export const addFinancialInvoice = params => {
    return axios.post(`${base}/financialRevenue/addFinancialInvoice`, params);
};
//提交申请
export const submitFinancialApplyInvoice = params => {
    return axios.post(`${base}/financialRevenue/submitFinancialApplyInvoice`, params);
};

//保存编辑
export const editFinancialInvoice = params => {
    return axios.post(`${base}/financialRevenue/editFinancialInvoice`, params);
};
//审核
export const reviewFinancialApplyInvoice = params => {
    return axios.post(`${base}/financialRevenue/reviewFinancialApplyInvoice`, params);
};
// 意见列表和汇总

// 获取我的待提交项目列表
export const getUncommitProjectList = params => {
    return axios.get(`${base}/drTask/getUncommitProjectList`, { params: params });
};

// 获取我的意见列表
export const getOpinionAllList = params => {
    return axios.get(`${base}/drOpinion/getOpinionAllList`, { params: params });
};

// 删除我的意见
export const deleteOpinion = params => {
    return axios.delete(`${base}/drOpinion/deleteOpinion`, { params: params });
};

// 提交我的意见
export const submitDrawingReviewReport = params => {
    return axios.post(`${base}/drOpinionSummary/submitDrawingReviewReport`,  params);
};

// // 根据项目id获取需要汇总的人员列表
// export const getGatherUserListByProjectId = params => {
//     return axios.get(`${base}/drTask/getGatherUserListByProjectId`, { params: params });
// };

// 获取我的待汇总项目列表
export const getUngatherProjectList = params => {
    return axios.get(`${base}/drTask/getUngatherProjectList`, { params: params });
};

// 获取用户项目任务详情
export const getUnFinishTaskListByUser = params => {
    return axios.get(`${base}/drTask/getUnFinishTaskListByUser`, { params: params });
};

// 根据项目id获取需要汇总的人员列表
export const getPeopleCount = params => {
    return axios.get(`${base}/drOpinionSummary/getPeopleCount`, { params: params });
};

// 获取自动汇总/指定人员的意见列表
export const getDrOpinionSummaryUnconfirmed = params => {
    return axios.get(`${base}/drOpinionSummary/getDrOpinionSummaryUnconfirmed`, { params: params });
};

// 获取自动汇总/指定人员的意见列表
export const getDrOpinionSummaryUnconfirmedForUser = params => {
    return axios.get(`${base}/drOpinionSummary/getDrOpinionSummaryUnconfirmedForUser`, { params: params });
};

// 获取已确认的意见列表
export const getDrOpinionSummaryConfirmed = params => {
    return axios.get(`${base}/drOpinionSummary/getDrOpinionSummaryConfirmed`, { params: params });
};

// 编辑已确认审查意见
export const updateConfirmedOpinion = params => {
    return axios.post(`${base}/drOpinionSummary/updateConfirmedOpinion`, params);
};

// 获取自动汇总的意见列表
export const getQuesTypeSummaryUnconfirmed = params => {
    return axios.get(`${base}/drOpinionSummary/getQuesTypeSummaryUnconfirmed`, { params: params });
};

// 生成报告
export const generatePreliminaryReviewReport = params => {
    return axios.get(`${base}/drOpinionSummary/generatePreliminaryReviewReport`, { params: params });
};

// 添加已确认审查意见
export const addOpinionConfirmed = params => {
    return axios.get(`${base}/drOpinionSummary/addOpinionConfirmed`, { params: params });
};

// 删除已确认的意见
export const deleteConfirmedOpinion = params => {
    return axios.delete(`${base}/drOpinionSummary/deleteConfirmedOpinion`, { params: params });
};

export const getNotificationWebsiteListPage = params => {
    return axios.get(`${base}/notificationWebsite/getNotificationWebsiteListPage`, { params: params });
};

export const getNotificationWebSiteUnReadCount = params => {
    return axios.get(`${base}/notificationWebsite/getNotificationWebsiteUnReadCount`, { params: params });
};


export const getGenWorkBriefList = params => {
    return axios.get(`${base}/genWorkBrief/getGenWorkBriefList`, { params: params });
};

// 修改站内通知记录已读状态
export const updateNotificationWebsiteIsRead = params => {
    return axios.post(`${base}/notificationWebsite/updateNotificationWebsiteIsRead`, params);
}

// 根据年、月、状态获取项目名称
export const getProjectNameList = params => {
    return axios.get(`${base}/zjjSt/getProjectList`, {params});
}

// 获取项目统计信息接口
export const getProjectStInfo = project_id => {
    return axios.get(`${base}/zjjSt/getProjectStInfo`, {params: {project_id: project_id}});
}

// 获取工作报告接口
export const getWorkReportList = (ddIdTimeType, pageIndex, pageSize) => {
    return axios.get(`${base}/zjjSt/getWorkReportList`, {params: {ddIdTimeType, pageIndex, pageSize}});
}

// 获取工作报告项目详情接口
export const getProjectDetailByWorkReport = (report_id, type) => {
    return axios.get(`${base}/zjjSt/getProjectDetailByWorkReport`, {params: {report_id, type}});
}

// 获取问题数接口
export const getQuestionDetailByWorkReport = (report_id, type) => {
    return axios.get(`${base}/zjjSt/getQuestionDetailByWorkReport`, {params: {report_id, type}});
}



// 新增客户端版本
export const addAppVersion = (req) => {
    return axios.post(`${base}/appVersion/addAppVersion`, req, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

// 删除客户端版本
export const deleteAppVersion = (params) => {
    return axios.delete(`${base}/appVersion/deleteAppVersion`, { params: params });
}

// 获取客户端版本分页列表
export const getAppVersionList = (params) => {
    return axios.get(`${base}/appVersion/getAppVersionList`, { params: params });
}

// 获取客户端版本分页列表
export const updateAppVersion = (params) => {
    return axios.post(`${base}/appVersion/updateAppVersion`, params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

//受领任务（列表）
export const getAssignList = params => {
    return axios.get(`${base}/drTask/getAssignList`, { params: params });
};
//受领任务开业检查
export const acceptKYJCTask = params => {
    return axios.get(`${base}/drTask/acceptKYJCTask`, { params: params });
};
//规范及条文库
//映射管理
export const getDrStandardItemRelationList = params => {
    return axios.get(`${base}/drStandardItem/getDrStandardItemRelationList`, { params: params });
};
//新增
export const addDrStandardItemRelation = params => {
    return axios.post(`${base}/drStandardItem/addDrStandardItemRelation`, params);
};
//删除
export const deleteDrStandardItemRelation = params => {
    return axios.delete(`${base}/drStandardItem/deleteDrStandardItemRelation`, { params: params });
};

// 场所登记
// 恢复项目
export const handleDemoProject = params => {
    return axios.get(`${base}/drProject/handleDemoProject`, { params: params });
}

//AI研发进度汇总
export const getStatisticsKYJCAiProgressList = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCAiProgressList`, { params: params });
}
//AI研发进度明细
export const getStatisticsKYJCAiProgressDetail = params => {
    return axios.get(`${base}/drProjectSt/getStatisticsKYJCAiProgressDetail`, { params: params });
}


//专家添加意见
export const addExpertOpinion = params => {
    return axios.post(`${base}/drOpinion/addOpinion`, params);
};
//技术部专家添加意见
export const addConfirmedOpinionByTechnology = params => {
    return axios.post(`${base}/drOpinionSummary/addConfirmedOpinionByTechnology`, params);
};

//获取报告中所有意见列表
export const getOpinionSummaryReportList = params => {
    return axios.get(`${base}/drOpinionSummary/getOpinionSummaryReportList`, { params: params });
}
//新增报告答疑内容
export const addOpinionSummaryReportGuestbook = params => {
    return axios.post(`${base}/drOpinionSummary/addOpinionSummaryReportGuestbook`, params);
}
//获取报告中所有答疑列表
export const getOpinionSummaryReportGuestbookList = params => {
    return axios.get(`${base}/drOpinionSummary/getOpinionSummaryReportGuestbookList`, { params: params });
}

//修改意见具体化
export const updateSpecificOpinion = params => {
    return axios.post(`${base}/drOpinion/updateSpecificOpinion`, params);
};

//获取开业检查申请表信息与上一次变更信息
export const getKYJCProjectApplicationLogByWorkflowNodeId = params => {
    return axios.get(`${base}/drProject/getKYJCProjectApplicationLogByWorkflowNodeId`, { params: params });
}
//检测用户项目任务是否完成
export const isFinishTaskByProjectId = params => {
    return axios.get(`${base}/drTask/isFinishTaskByProjectId`, { params: params });
}

//获取未汇总的项目列表
export const getProjectListByUngather = params => {
    return axios.get(`${base}/drProject/getProjectListByUngather`, { params: params });
}
//汇总意见条合并（第一步）
export const getMergeOpinionSummaryReportListByStepOne = params => {
    return axios.get(`${base}/drOpinionSummary/getMergeOpinionSummaryReportListByStepOne`, { params: params });
}
//汇总意见条合并（第二步）
export const getMergeOpinionSummaryReportListByStepTwo = params => {
    return axios.get(`${base}/drOpinionSummary/getMergeOpinionSummaryReportListByStepTwo`, { params: params });
}
//更新合并报告的具体化意见
export const updateConfirmProblemByOpinionSummaryReport = params => {
    return axios.post(`${base}/drOpinionSummary/updateConfirmProblemByOpinionSummaryReport`, params);
};

//以问题分类模式获取待确认审查意见列表（专家单人）
export const getQuesTypeSummaryUnconfirmedForUser = params => {
    return axios.get(`${base}/drOpinionSummary/getQuesTypeSummaryUnconfirmedForUser`, { params: params });
};
//报告中是否显示此意见
export const updateShowOpinionSummaryReport = params => {
    return axios.post(`${base}/drOpinionSummary/updateShowOpinionSummaryReport`, params);
}
//浏览初审报告
export const reportPreview = params => {
    return axios.get(`${base}/drOpinionSummary/reportPreview`, { params: params });
}

//识别开业检查word申请表
export const ocrKYJCApplicationWord = `${base}/kyjcAdmin/ocrApplicationWord`

export const addKYJCAdminProject = params => {
    return axios.post(`${base}/kyjcAdmin/addProject`, params);
};
//更新开业检查项目申报表
export const updateKYJCAdminProject = params => {
    return axios.post(`${base}/kyjcAdmin/updateProject`, params);
};


export const getKYJCProjectFileInfo = params => {
    return axios.get(`${base}/kyjcAdmin/getProjectFileInfo`, { params: params });
};

//上传
export const addKYJCProjectFile = params => {
    return axios.post(`${base}/kyjcAdmin/addProjectFile`, params);
};

export const deleteKYJCProjectFile = params => {
    return axios.post(`${base}/kyjcAdmin/deleteProjectFile`, params);
};

export const deleteProjectFile = params => {
    return axios.post(`${base}/kyjcAdmin/deleteProjectFile`, params);
};

// 获取项目操作日志列表
export const getProjectOperationLogList = params => {
    return axios.get(`${base}/drProject/getProjectOperationLogList`, { params: params });
};

export const getDepartmentListByUserId = params => {
    return axios.get(`${base}/userInfo/getDepartmentListByUserId`, { params: params });
};

// 获取意见坐标信息的图纸
export const getOpinionDrawingInfo = params => {
    return axios.get(`${base}/drOpinion/getOpinionDrawingInfo`, { params: params });
};

export const getKYJCAreaData = params => {
    return axios.get(`${base}/drProject/getKYJCAreaData`, { params: params });
};

//修改是否专家意见
export const updateIsExpertOpinion = params => {
    return axios.post(`${base}/drOpinion/updateIsExpertOpinion`, params);
};

// 获取汇总意见图纸坐标列表
export const getSummaryOpinionDrawingList = params => {
    return axios.get(`${base}/drOpinionSummary/getSummaryOpinionDrawingList`, { params: params });
};

// 获取汇总意见坐标信息的图纸
export const getSummaryOpinionDrawingInfo = params => {
    return axios.get(`${base}/drOpinionSummary/getSummaryOpinionDrawingInfo`, { params: params });
};

export const updateMainOpinionId = params => {
    return axios.post(`${base}/drOpinionSummary/updateMainOpinionId`, params);
};

// 获取汇总问题意见列表
export const getSummaryOpinionListByWorkFlowNodeId = params => {
    return axios.get(`${base}/drOpinionSummary/getSummaryOpinionListByWorkFlowNodeId`, { params: params });
};